import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "eszpcu-0"
})(["display:flex;flex-direction:column;width:100%;&:not(:first-child){", "}", ";"], function (_ref) {
  var row = _ref.row;
  return row ? "margin-top: 1rem;" : "margin-top: 0.7rem;";
}, function (_ref2) {
  var row = _ref2.row;
  return row && "flex-direction: row;";
});